<template>
	<VExpansionPanels
		:accordion="true"
		flat
		class="rounded-lg"
		style="border: solid 1px #e0e0e0"
		focusable
	>
		<VExpansionPanel
			v-for="(item, index) in items"
			:key="index"
		>
			<VExpansionPanelHeader
				:class="$isMobile() ? 'text-subtitle-2' : 'text-subtitle-1'"
				class="d-flex justify-space-between"
			>
				<template #default="{ open }">
					<span>{{ item.title }}</span>
					<div
						v-if="item.examplePathRequired && !$isMobile() && !open"
						class="d-flex justify-end"
					>
						<a
							:href="item.examplePath"
							target="_blank"
						>
							<DownloadBtn
								class="pl-2 mr-2"
								width="155px"
								style="width: 155px !important;"
								:file-promise="() => {}"
							>
								{{ $t('components.documentDescriptions.download') }}
							</DownloadBtn>
						</a>
					</div>
				</template>
			</VExpansionPanelHeader>
			<VExpansionPanelContent>
				<div
					class="d-flex align-center pb-2 pt-6 h-100"
					:class="$isMobile() ? 'flex-column' : 'flex-row'"
				>
					<div
						v-if="item.examplePath && !$isMobile()"
						class="d-flex flex-column align-center"
					>
						<img
							src="@/assets/images/document.png"
							:alt="item.title"
							height="136px"
							style="min-width: 136px"
							class="mb-6"
						>
						<a
							:href="item.examplePath"
							target="_blank"
						>
							<DownloadBtn
								class="pl-2 py-2"
								width="155px"
								:file-promise="() => {}"
							>
								{{ $t('components.documentDescriptions.download') }}
							</DownloadBtn>
						</a>
					</div>
					<div
						v-if="item.examplePath && !$isMobile()"
						class="mx-6 sep-x h-100"
					/>
					<p v-html="item.content" />
					<div
						v-if="item.examplePath && $isMobile()"
						class="w-100"
					>
						<div class="w-100 my-6 sep-y" />
						<a
							:href="item.examplePath"
							target="_blank"
						>
							<DownloadBtn
								class="pl-2 py-2 mx-auto d-flex"
								width="155px"
								:file-promise="() => {}"
							>
								{{ $t('components.documentDescriptions.download') }}
							</DownloadBtn>
						</a>
					</div>
				</div>
			</VExpansionPanelContent>
			<div
				v-if="index !== items.length - 1"
				style="height: 1px; background-color: #e0e0e0"
			/>
		</VExpansionPanel>
	</VExpansionPanels>
</template>

<script lang="ts">
	import Vue, { PropType } from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { DocumentDescriptionItem } from '@/types';

	const Props = Vue.extend({
		props: {
			items: {
				type: Array as PropType<DocumentDescriptionItem[]>,
				required: true
			}
		}
	});

	@Component
	export default class DocumentDescription extends mixins(Props) {}
</script>

<style lang="scss" scoped>
@import '@cnamts/design-tokens/dist/tokens';

:deep(.warn) ::after {
  color: $vd-yellow-base;
}
.sep-x {
  width: 1px;
  background-color: $vd-grey-lighten-80;
}
.sep-y {
	height: 1px;
	background-color: $vd-grey-lighten-80;
}
</style>
